import { NavDropdown } from 'react-bootstrap';
import { LinkDropDownItem } from '@ping/components/Header/LinkDropDownItem';
import { LinkProps } from 'next/link';
import { ReactElement } from 'react';
import clsx from 'clsx';

import style from './style.module.scss';

type TLinkDropDownItem = {
  href: LinkProps['href'];
  title: string;
  subtitle: string;
  icon: ReactElement;
};

interface IProps {
  title: string;
  disabled: boolean;
  link: TLinkDropDownItem[];
  className?: string;
  dropdownId?: string;
  dataTestId?: string;
}

export const LinkWithDropdown = ({ title, disabled, link, className, dropdownId, dataTestId }: IProps) => {
  return (
    <NavDropdown
      data-testid={dataTestId ?? 'trade-dropdown'}
      id={dropdownId ?? style['trade-dropdown']}
      title={title}
      className={clsx(style['header__link'], className)}
      disabled={disabled}
    >
      {link?.map(item => {
        return (
          <NavDropdown.Item className={style['trade__dropdown-item']} key={item.title}>
            <LinkDropDownItem title={item.title} subtitle={item.subtitle} icon={item.icon} href={item.href} />
          </NavDropdown.Item>
        );
      })}
      {!link || (link.length === 0 && null)}
    </NavDropdown>
  );
};
